import { useQuery } from "@tanstack/react-query";
import { Axios } from "../utils/Axios";

export function useSalesSummary() {
    return useQuery({
        queryKey: ['salesSummary'],
        queryFn: async () => {
            const summary = await Axios.get('/analytics/sales-summary');
            return summary.data?.data
        },
    })
}